<div *ngIf="config">

    <mat-card *ngIf="isError" class="card-light error-panel">
        <mat-card-title>{{ 'ASSESSMENT.ERROR_TITLE' | translate }}</mat-card-title>
        <mat-card-content>
            {{ errorMessage }}<br>
            {{ 'ASSESSMENT.ERROR_MESSAGE' | translate }}
        </mat-card-content>
    </mat-card>
    
    <div *ngIf="data">
        <div *ngIf="!success && displayReview">
            <section class="head-section">
                <div class="container container-extra no-horizontal-padding">                
                    <app-product-guide category="assessment" [productType]="data.reviewPeriodEmployee.reviewPeriod.reviewType"></app-product-guide>                    
                </div>
            </section>
            <section class="body-section">
                <div class="container container-extra">

                    <mat-toolbar *ngIf="isTestMode" class="test-actionbar">
                        <button mat-icon-button class="example-icon" aria-label="toolbar icon">
                            <mat-icon>menu</mat-icon>
                        </button>
                        <span>{{ 'ASSESSMENT.TEST_TOOLBAR' | translate }}</span>
                        <span class="actionbar-spacer"></span>
                        <button mat-flat-button color="primary" (click)="testComplete()" [title]="'ASSESSMENT.AUTO_FILL_TITLE' | translate">{{ 'ASSESSMENT.AUTO_FILL_BUTTON' | translate }}</button>
                    </mat-toolbar>

                    <div *ngIf="reviewType === reviewTypes.TER" class="person-info-panel">
                        <h1 class="text-center text-34">
                            <span>{{ config.t.assessment.title }}</span>
                            <span *ngIf="config.c.assessment.showEmail">{{ data.colleague | employeeName:'identifier' }}</span>
                        </h1>
                        <h5 class="text-center" *ngIf="config.c.assessment.showReviewPeriod && reviewPeriodHasDate(data.reviewPeriodEmployee.reviewPeriod)">
                            {{ 'ASSESSMENT.ASSESSMENT_PERIOD' | translate }} {{ data.reviewPeriodEmployee.reviewPeriod.name }}<br>
                            <div *ngIf="data.reviewPeriodEmployee.reviewPeriod?.endDate">
                                {{ 'ASSESSMENT.DEADLINE' | translate }} {{ data.reviewPeriodEmployee.reviewPeriod.endDate | datePlain }}
                            </div>
                        </h5>
                    </div>

                    <div *ngIf="reviewType === reviewTypes.MilioTeamDysfunction || reviewType === reviewTypes.MilioStressMap">
                        
                        <mat-card class="card-group card-light group-panel-margin">
                            <mat-card-content class="text-center info-block">
                                <div class="details">
                                    <div><span class="font-weight-bold">{{ 'ASSESSMENT.TEAM_NAME' | translate }}</span>{{ data.reviewPeriodEmployee.reviewPeriod.name }}</div>
                                    <div><span class="font-weight-bold">{{ 'ASSESSMENT.PARTICIPANT_COUNT' | translate }}</span>{{ data.employeeCount }}</div>
                                    <div *ngIf="data.reviewPeriodEmployee.reviewPeriod.startDate && data.reviewPeriodEmployee.reviewPeriod.endDate">
                                        <span class="font-weight-bold">{{ 'ASSESSMENT.COMPLETION_PERIOD' | translate }}</span>{{ data.reviewPeriodEmployee.reviewPeriod.startDate | datePlain }} - {{ data.reviewPeriodEmployee.reviewPeriod.endDate | datePlain }}
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>

                        <mat-card class="question card-light" *ngIf="reviewType === reviewTypes.MilioTeamDysfunction">
                            <mat-card-title>
                                {{ 'ASSESSMENT.MILIO_TEAM_DYSFUNCTION_INSTRUCTION' | translate }}
                            </mat-card-title>
                        </mat-card>

                        <mat-card class="question card-light" *ngIf="reviewType === reviewTypes.MilioStressMap">
                            <mat-card-title>
                                {{ 'ASSESSMENT.MILIO_STRESS_MAP_INSTRUCTION' | translate }}
                            </mat-card-title>
                        </mat-card>
                        
                    </div>

                    <form>                            

                       <ng-container *ngIf="modules.length > 0">
                           <app-question #questions *ngFor="let qModule of modules; index as i" 
                               [editable]="false" 
                               [textblock]="qModule"
                               [index]="i+1"
                               [questionOptions]="createQuestionOptions(data)"></app-question>
                          
                        <div *ngIf="isBlue()" class="padding-lg">
                            <div class="m-down">What are the three main strengths of the person being evaluated, with examples that show them in action, and three areas where they could further develop, also supported by examples?</div>
                            <mat-form-field appearance="outline" *ngIf="isFreeTextAllowed(data.freeText)" class="freetext">
                                <textarea matInput name="freetext" [(ngModel)]="data.freeText.text" (change)="freeTextChanged(data.freeText)"></textarea>
                            </mat-form-field>
                        </div>

                        <ng-container *ngIf="!isBlue()">
                            <mat-form-field appearance="outline" *ngIf="isFreeTextAllowed(data.freeText)" class="freetext padding-lg">
                                <mat-label>{{ 'ASSESSMENT.FREE_TEXT_LABEL' | translate }}</mat-label>
                                <textarea matInput name="freetext" [(ngModel)]="data.freeText.text" (change)="freeTextChanged(data.freeText)"></textarea>
                            </mat-form-field>
                        </ng-container>

                       </ng-container>
            
                        <validation-messages [msgList]="messages"></validation-messages>
            
                        <div class="actions">
                            <div class="button-panel">
                                <button mat-flat-button #finish color="accent" [disabled]="!isReviewCanComplete(data)" (click)="complete(data)" [title]="'ASSESSMENT.COMPLETE_BUTTON_TITLE' | translate">{{ 'ASSESSMENT.COMPLETE_BUTTON' | translate }}</button>
                            </div>
                            <div class="button-panel">
                                <button mat-flat-button (click)="cancel()">{{ 'ASSESSMENT.BACK_BUTTON' | translate }}</button>
                            </div>
                        </div>
            
                    </form>
                </div>
            </section>
        </div>
        
        <div *ngIf="success" class="success-panel">
            <section class="head-section">
                <div class="container container-extra no-horizontal-padding">
                    <h3 class="text-center margin-bottom-xl" *ngIf="data.reviewPeriodEmployee.reviewPeriod.reviewType != reviewTypes.PersonalityTest">{{ 'ASSESSMENT.THANK_YOU_TITLE' | translate }}</h3>

                    <article class="margin-bottom-xl" *ngIf="data.reviewPeriodEmployee.reviewPeriod.reviewType == reviewTypes.PersonalityTest">
                        <h3 class="text-center">{{ 'ASSESSMENT.PERSONALITY_TEST_THANK_YOU_TITLE' | translate }}</h3>
                        <p class="text-center">{{ 'ASSESSMENT.PERSONALITY_TEST_THANK_YOU_MESSAGE' | translate }}</p>
                    </article>
                </div>
            </section>
            <section class="body-section">
                <div class="container container-extra">
                    
                    <div class="feedback-panel">
                        <mat-card class="card-light" *ngIf="data.reviewPeriodEmployee.reviewPeriod.reviewType == reviewTypes.PersonalityTest">
                            <mat-card-header>
                                <mat-card-title>
                                    {{ 'ASSESSMENT.FEEDBACK_TITLE' | translate }}
                                </mat-card-title>
                                <mat-card-subtitle>
                                    {{ 'ASSESSMENT.FEEDBACK_SUBTITLE' | translate }}
                                </mat-card-subtitle>
                            </mat-card-header>
                            <mat-card-content>
                                <mat-form-field appearance="outline">
                                    <textarea matInput name="feedback" [(ngModel)]="feedback" [title]="'ASSESSMENT.FEEDBACK_TITLE' | translate" [ngModelOptions]="{debounce: 1000, allowInvalid: false, standalone: true}" autocomplete="off" (change)="saveFeedback(data)"></textarea>
                                </mat-form-field>

                            </mat-card-content>
                        </mat-card>

                        <div class="actions">
                            <button mat-flat-button color="primary" [routerLink]="['/']">{{ 'ASSESSMENT.BACK_TO_MAIN' | translate }}</button>
                            <button mat-flat-button color="primary" [routerLink]="getReportLink(data)" *ngIf="data.reviewPeriodEmployee.reviewPeriod.reviewType == reviewTypes.PersonalityTest">{{ 'ASSESSMENT.VIEW_REPORT' | translate }}</button>
                        </div>
                    </div>

                </div>
            </section>           
                        
        </div>

    </div>    
</div>

<app-page-progress *ngIf="!success" [value]="progressValue" [currentItem]="completeCount"  [maxItems]="allQuestionsCount"></app-page-progress>
